import AppLogo from '@assets/images/oplii-logo.png';

const Logo = () => {
  return <img className="inline-block op-logo-img" src={AppLogo} />;
};

export default Logo;
